$(".c-btn__search").click(function () {
	$(this).toggleClass("btnactive");
	$("#search-wrap").toggleClass("panelactive");
	$("#search-text").focus();
});
$("#search-submit").click(function () {
	$("#search-wrap").removeClass("panelactive");
	$(".c-btn__search").removeClass("btnactive");
});
